export default __webpack_public_path__ + "static/media/instagram.28e92594.svg";